export const CUSTOMER_QUERY_KEY = ['customer'] as const

export const DEFAULT_LOCATION_NAME = 'DEFAULT_LOCATION_NAME' as const
